// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"J_b5","light":"J_s","logo":"J_b6","icon":"J_bJ","studio":"J_j","title":"J_p","iconDark":"J_b7","hidden":"J_0","right":"J_bw"};